module.exports = __webpack_public_path__ + "static/media/LowPerformance_02.fd89dad6.svg";